import defaultTheme from '@/themes/default';

const state = {
	mainMenu: {},
	footerLinks: {},
	theme: {
		...defaultTheme,
	},
};

export { state as default };
